import { getFormValues } from "redux-form";
import { createSelector } from "reselect";

export const getProductDescription = form =>
  createSelector(getFormValues(form), data => data || {});
